import { Helmet } from "react-helmet";
import { SideBar } from "../side-bar/SideBar";
import { useAuth } from "../../../services/auth-services/authContext";
import { AuthContextState } from "../../../utils/types";
import React, { useEffect, useState } from "react";
import DashboardUnavailable from "./DashboardUnavailable";
import UsersDetails from "./user-details-cards/UsersDetails";
import DepartmentDetails from "./department-details-cards/department-cards";
import AttendanceDetails from "./attendance-cards/Attendance.Details";

export default function Dashboard (){

    const {decodedJwtData} = useAuth() as AuthContextState;
    const [dashboardContent, setDashboardContent] = useState<React.JSX.Element[]>([]);

    const users_priv = decodedJwtData?.account_priv;

    useEffect(()=>{
        const assignDashboardContent = () =>{
            if(!users_priv) return false;
            const contents : React.JSX.Element[] = [];
            users_priv.forEach((priv : number)=>{
                switch(priv){
                    case 1:
                        contents.push(<UsersDetails />);
                        break;
                    case 2:
                        contents.push(<DepartmentDetails />);
                        break;
                    case 4:
                        contents.push(<AttendanceDetails />);
                        break;
                }
            })
            if(contents) setDashboardContent(contents);
        }
        assignDashboardContent();
    },[users_priv]);

    return (
        <div className="content flex">
            <Helmet>
                <title>Dashboard</title>
            </Helmet>

            <SideBar />
            
            <div className='main-content relative'>
                {dashboardContent.length > 0 ? (
                    <div className="flex flex-col gap-2">
                        <div>
                            Overview
                        </div>
                        {dashboardContent}
                    </div>
                ):(
                    <DashboardUnavailable />
                )}
            </div>

        </div>
    );
}